import React from 'react';
import image from './assets/logo192.png';
const Logo = ()=>{
    return (

        <div className='max-w-md mx-auto relative top-9'>

            <h2 className="flex flex-row flex-nowrap items-center my-8">
                <span className="flex-grow block border-t border-black" aria-hidden="true" role="presentation"></span>
                <span className="flex-none block mx-4 px-4 py-2.5 text-lg leading-none font-medium bg-black text-white">
                    Career GPT
                </span>
                <span className="flex-grow block border-t border-black" aria-hidden="true" role="presentation"></span>
            </h2>


    <img src={image} alt="Career GPT" className="h-auto w-auto" />
  </div>
    )
}
export default Logo;